webpackJsonp([10,11],{

/***/ 145:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            viewType: '',
	            code: 0,
	            order_id: 0,
	            currency: 0,
	            recharge_amount: 0
	        };
	    },
	
	    methods: {
	        heights: function heights() {
	            var contentHeight = $(window).height() / 30 + '%';
	            $(".section").css("margin-top", '' + contentHeight + '');
	        },
	        clicks: function clicks() {
	            setTimeout("$('#test').trigger('click')", 200);
	            setTimeout("$('#close').trigger('click')", 5000);
	        },
	        closes: function closes() {
	            console.log(this.$route.query.type);
	            window.close();
	        }
	    },
	    created: function created() {
	        this.clicks();
	        var type = this.$route.query.type;
	        var code = this.$route.query.code;
	        var order_id = this.$route.query.order_id;
	        var currency = this.$route.query.currency;
	        var recharge_amount = this.$route.query.recharge_amount;
	        this.viewType = type;
	        this.code = code;
	        this.order_id = order_id;
	        this.currency = currency;
	        this.recharge_amount = recharge_amount;
	    }
	};

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-6a66377c]{visibility:hidden;height:0}.el-row[data-v-6a66377c]{margin-bottom:20px}.el-row[data-v-6a66377c]:last-child{margin-bottom:0}.el-col[data-v-6a66377c]{border-radius:4px}.bg-purple-dark[data-v-6a66377c]{background:#99a9bf}.bg-purple[data-v-6a66377c]{background:#d3dce6}.bg-purple-light[data-v-6a66377c]{background:#e5e9f2}.grid-content[data-v-6a66377c]{border-radius:4px;min-height:36px}.row-bg[data-v-6a66377c]{background-color:#f9fafc}.text[data-v-6a66377c]{font-size:14px}.item[data-v-6a66377c]{padding:18px 0}.clearfix[data-v-6a66377c]:after,.clearfix[data-v-6a66377c]:before{display:table;content:\"\"}.clearfix[data-v-6a66377c]:after{clear:both}.box-card[data-v-6a66377c]{margin:0 auto;width:480px}", "", {"version":3,"sources":["/./src/components/Result.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,yBAAyB,kBAAkB,CAC1C,AACD,oCAAoC,eAAe,CAClD,AACD,yBAAyB,iBAAiB,CACzC,AACD,iCAAiC,kBAAkB,CAClD,AACD,4BAA4B,kBAAkB,CAC7C,AACD,kCAAkC,kBAAkB,CACnD,AACD,+BAA+B,kBAAkB,eAAe,CAC/D,AACD,yBAAyB,wBAAwB,CAChD,AACD,uBAAuB,cAAc,CACpC,AACD,uBAAuB,cAAc,CACpC,AACD,mEAAmE,cAAc,UAAU,CAC1F,AACD,iCAAiC,UAAU,CAC1C,AACD,2BAA2B,cAAc,WAAW,CACnD","file":"Result.vue","sourcesContent":["\n.blank[data-v-6a66377c]{visibility:hidden;height:0\n}\n.el-row[data-v-6a66377c]{margin-bottom:20px\n}\n.el-row[data-v-6a66377c]:last-child{margin-bottom:0\n}\n.el-col[data-v-6a66377c]{border-radius:4px\n}\n.bg-purple-dark[data-v-6a66377c]{background:#99a9bf\n}\n.bg-purple[data-v-6a66377c]{background:#d3dce6\n}\n.bg-purple-light[data-v-6a66377c]{background:#e5e9f2\n}\n.grid-content[data-v-6a66377c]{border-radius:4px;min-height:36px\n}\n.row-bg[data-v-6a66377c]{background-color:#f9fafc\n}\n.text[data-v-6a66377c]{font-size:14px\n}\n.item[data-v-6a66377c]{padding:18px 0\n}\n.clearfix[data-v-6a66377c]:before,.clearfix[data-v-6a66377c]:after{display:table;content:\"\"\n}\n.clearfix[data-v-6a66377c]:after{clear:both\n}\n.box-card[data-v-6a66377c]{margin:0 auto;width:480px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(253);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6a66377c&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Result.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6a66377c&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Result.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(305)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(145),
	  /* template */
	  __webpack_require__(383),
	  /* scopeId */
	  "data-v-6a66377c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 383:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "finsh-page"
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "grid-content"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "offset": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content"
	  }, [_c('div', {
	    staticClass: "section"
	  }, [(_vm.viewType === 'success') ? _c('div', [_c('el-alert', {
	    attrs: {
	      "title": _vm.$t('rechargeFinish'),
	      "type": "success",
	      "description": _vm.$t('rechargeFinishCheckLater'),
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "box-card"
	  }, [_c('div', {
	    staticClass: "text item"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ": " + _vm._s(_vm.order_id))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('rechargeAmount')) + ": " + _vm._s(_vm.recharge_amount) + " " + _vm._s(_vm.currency))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.viewType === 'finsh') ? _c('div', [_c('el-alert', {
	    attrs: {
	      "title": _vm.$t('rechargeFinish'),
	      "type": "success",
	      "description": _vm.$t('rechargeFinishCheckLater'),
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "box-card"
	  }, [_c('div', {
	    staticClass: "text item"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ":" + _vm._s(_vm.order_id))]), _vm._v(" "), _c('br')])])], 1) : _vm._e(), _vm._v(" "), (_vm.viewType === 'fail') ? _c('div', [_c('el-alert', {
	    attrs: {
	      "title": _vm.$t('rechargeFail'),
	      "type": "warning",
	      "description": _vm.$t('rechargeFailErrCode'),
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "box-card"
	  }, [_c('div', [_vm._v("code: " + _vm._s(_vm.code))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ": " + _vm._s(_vm.order_id))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "test"
	    },
	    on: {
	      "click": _vm.heights
	    }
	  }, [_vm._v("位置")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "close"
	    },
	    on: {
	      "click": _vm.closes
	    }
	  }, [_vm._v("关闭")])])])])], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.6b9156b228ef9ab9a564.js